<template>
  <div>
    <define-table :data="machineList" height="450px" class="table" :haveIndex="true" :havePage="false" @changeCurrent="change" :highLightCurrent="true">
      <define-column field="number" label="编号" width="180"></define-column>
      <define-column field="machineManufacturer" label="生产厂商"></define-column>
      <define-column field="warpKnittingMachineAxialLength" label="经编机轴向长度"></define-column>
      <define-column field="warpKnittingMachineMaxComb" label="经编机最大梳理量"></define-column>
      <define-column v-slot="{ data }" label="机台状态">
        <el-tag v-if="data.row.machineState == 'STAND'" type="warning" >待机</el-tag>
        <el-tag v-if="data.row.machineState  == 'SHUTDOWN'" type="warning" >关机</el-tag>
        <el-tag v-if="data.row.machineState  == 'ABNORMAL'" type="danger" >异常停机</el-tag>
        <el-tag v-if="data.row.machineState  == 'THREADING'" type="warning" >穿纱</el-tag>
        <el-tag v-if="data.row.machineState  == 'FEEDING'" type="success" >上料</el-tag>
        <el-tag v-if="data.row.machineState  == 'REPAIR'" >维修</el-tag>
        <el-tag v-if="data.row.machineState  == 'NORMAL_PRODUCTION'" type="success" >正常生产</el-tag>
      </define-column>

    </define-table>

    <div class="footer">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="selected">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'machine',
  data () {
    return {
      machineList: [],
      select: {}
    }
  },
  methods: {
    change (val) {
      this.select = val.current
      this.select.ManufacturerName = val.current.machineManufacturer
    },
    cancel () {
      this.$emit('cancel')
    },
    selected () {
      console.log(this.select)
      this.$emit('select', { data: this.select, ref: 'machine' })
    },
    getMachineList () {
      var data = { page: 1, size: 99 }
      this.$request({
        url: '/machine/findList',
        method: 'GET',
        params: data
      }).then(res => {
        this.machineList = res.data.content
      })
    }
  },
  created () {
    this.getMachineList()
  }
}
</script>

<style scoped>
.footer {
  margin: 10px;
  display: flex;
  justify-content: flex-end;
}
.add {
  float: right;
}
</style>
